import { DataTable } from "@/components/shared/data-table";
import { Badge } from "@/components/ui/badge";
import type { Client } from "@/lib/coach-manager/types";

interface ClientsTableProps {
  clients: Client[];
}

function formatCellValue(value: string | undefined): string {
  return value && value.length > 0 ? value : "—";
}

/**
 * The matrix list of matched Clients — mirrors `ContractsTable`'s shape.
 * Client's narrow, flat shape doesn't need a detail drawer the way Contract's
 * deeply-nested tree does — the row itself carries everything worth showing.
 */
export function ClientsTable({ clients }: ClientsTableProps) {
  return (
    <DataTable
      headers={[
        { label: "Client ID" },
        { label: "Company" },
        { label: "Surname" },
        { label: "First Name" },
        { label: "Postcode" },
        { label: "Email" },
        { label: "Status" },
      ]}
    >
      {clients.map((client) => (
        <tr
          key={client.ClientID ?? `${client.Surname}-${client.Company}`}
          className="border-b last:border-b-0 hover:bg-muted/40"
        >
          <td className="px-4 py-2 font-medium">{formatCellValue(client.ClientID)}</td>
          <td className="px-4 py-2">{formatCellValue(client.Company)}</td>
          <td className="px-4 py-2">{formatCellValue(client.Surname)}</td>
          <td className="px-4 py-2">{formatCellValue(client.FirstName)}</td>
          <td className="px-4 py-2">{formatCellValue(client.Postcode)}</td>
          <td className="px-4 py-2">{formatCellValue(client.Email)}</td>
          <td className="px-4 py-2">
            {client.Deleted ? (
              <Badge variant="destructive">Deleted</Badge>
            ) : client.Suspend ? (
              <Badge variant="destructive">Suspended</Badge>
            ) : (
              <Badge variant="success">Active</Badge>
            )}
          </td>
        </tr>
      ))}
    </DataTable>
  );
}
